// import validate from "validate.js";

export default class SayHelloForm {
  constructor() {
    this.allTabs = document.querySelectorAll(".form-tab");
    this.type = document.getElementById("input_1_6");
    this.tabStyle();
  }

  tabStyle() {
    this.allTabs.forEach((item) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();
        this.cleanTabStyle();
        const value = event.target.getAttribute("data-type");
        this.type.value = value;
        event.target.classList.add("active");
      });
    });
  }

  cleanTabStyle() {
    this.allTabs.forEach((item) => {
      item.classList.remove("active");
    });
  }
}
